import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import './exemption-card.scss';

@customElement('sbk-exemption-card')
export class SbkExemptionCard extends LitElement {

    protected createRenderRoot() {
        return this;
    }
}
